<template>
    <div class="bg-item-box">
        <img class="bg-item-cover" :src="
            itemCover && itemCover != 'null'
                ? $global.imgUrl + itemCover
                : require('@/assets/img/mobile-img/zz_default.png')
        " alt="" />
        <div class="bg-item-text">
            <h3 class="bg-item-title" v-html="title"></h3>
            <div v-if="isExtend">
                <p class="extend-text">
                    预计赚¥<span class="extend-text-price">{{ extendPrice }}</span>
                </p>
                <p class="extend-price">
                    <span v-show="formatePrice !== '免费'" class="bg-item-icon">¥</span>
                    <span class="bg-item-price">{{ formatePrice }}</span>
                </p>
            </div>
            <div v-else>
                <div class="bg-item-tags">
                    <div class="item-tag item-tags-one" v-if="industryOne">#{{ industryOne }}</div>
                    <div class="item-tag" v-if="industryTwo">#{{ industryTwo }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    props: ["cover", "title", "price", "isExtend", "extendPrice", "isReport", "industryOne", "industryTwo"],
    data() {
        return {
            searchStr: "",
        };
    },
    computed: {
        itemCover() {
            return this.cover ? this.cover.split(',')[0] : null
        },
        formatePrice() {
            if (typeof(this.price) === 'string') {
                if (this.price === '0') {
                    return "免费"
                }
                return this.price
            } else {
                if (this.price.length > 1) {
                    return `${this.price[0]}-${this.price[this.price.length - 1]}`
                } else {
                    return this.price[0] > 0 ? `${this.price[0]}` : "免费"
                }
            }
        },
        // highLightTitle() {
        //     return this.title.replaceAll(
        //         this.searchStr,
        //         `<span style="color:#517EF2">${this.searchStr}</span>`
        //     );
        // },
    },
    created() {
        // this.searchStr = this.$route.query.paramStr;
    },
};
</script>
  
<style scoped lang="scss">
.bg-item-box {
    background: #ffffff;
    border-radius: 6px;
    overflow: hidden;

    .bg-item-cover {
        width: 100%;
        height: 170px;
        object-fit: contain;
        background-color: #EDEDED;
    }

    .bg-item-text {
        // display: flex;
        // flex-direction: column;
        // justify-content: space-between;
        padding: 5px 10px 10px;
        // height: 86px;

        .bg-item-title {
            margin-bottom: 10px;
            height: 40px;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .bg-item-tags {
            display: flex;
            font-size: 12px;
            color: #999999;
            line-height: 16px;
            .item-tag {
                max-width: 67px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
            }
            .item-tags-one {
                margin-right: 12px;
            }
        }

        .bg-item-icon {
            font-size: 12px;
            color: #ff3d3d;
        }

        .bg-item-price {
            font-size: 15px;
            font-weight: 700;
            color: #ff3d3d;
        }

        .extend-text {
            font-size: 12px;
            color: #ff3d3d;

            .extend-text-price {
                font-size: 16px;
                font-weight: 700;
            }
        }

        .extend-price {
            .bg-item-icon {
                color: #999999;
            }

            .bg-item-price {
                font-size: 12px;
                color: #999999;
            }
        }
    }
}
</style>